import { render, staticRenderFns } from "./goods_verify.vue?vue&type=template&id=3c0270fa&scoped=true"
import script from "./goods_verify.vue?vue&type=script&lang=js"
export * from "./goods_verify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0270fa",
  null
  
)

export default component.exports